import { render, staticRenderFns } from "./SettingsMenuView.vue?vue&type=template&id=097c8b07&"
import script from "./SettingsMenuView.vue?vue&type=script&lang=js&"
export * from "./SettingsMenuView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMenuView.vue?vue&type=style&index=0&id=097c8b07&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports